var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.10815 27H0.670776V1.529L0.9716 1.24694C1.19289 1.03842 2.51677 0 6.82836 0C9.21507 0 11.8846 0.88654 14.2399 1.66821C16.1366 2.29801 17.9281 2.89286 19.1435 2.89286C21.8907 2.89286 23.8079 2.03404 23.8259 2.025L25.3011 1.35362V16.9889L24.7341 17.2553C24.6411 17.2969 22.4269 18.3214 19.1435 18.3214C17.5952 18.3214 15.6555 17.8911 13.6023 17.4349C11.2945 16.9226 8.90847 16.3929 6.82836 16.3929C4.46346 16.3929 3.63796 16.7292 3.10815 16.9419V27Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhaseIcon);
export default __webpack_public_path__ + "static/media/phase-icon.d72f4365844482640b5879833f94b143.svg";
export { ForwardRef as ReactComponent };